<template>
  <div class="form-template scrollable">
    <div class="result-area confirmation" v-if="getShowConfirmation">
      <div v-if="getConfirmationType === 'recipe'" id="klarna-confirmation"></div>
      <div v-if="getConfirmationType === 'psychologist' && everythingHasBeenConfirmed" class="psychology-confirmation">
        <h2>Bekräftelse</h2>
        Ditt formulär har nu skickats till din digitala journal. Du kommer att kontaktas av Vega Psykologi inom 1-2 veckor för att boka tid för samtal. Ni kan själv komma överens om ni föredrar digitalt eller fysiskt möte. 
      </div>
      <div class="form-error-message">
        <a href="/" class="back-home-link">
          <div class="form-button"><span class="icon"><Zondicon icon="ArrowThinLeft" /></span> Tillbaka till start</div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import axios from "axios"

export default {
  props: ['sid'],
  data() {
    return {
      orderId: "",
      product: "",
      orderCompletedAt: "",
      phone: "",
      response: "",
      order: {},
      firstname: "",
      lastname: "",
      email: "",
      pnr: "",
      preview: "",
      kaddiopreview: "",
      preferredContact: "",
      everythingHasBeenConfirmed: false

    }
  },
  computed: {
    ...mapGetters("persist", [
      "getShowConfirmation",
      "getConfirmationType",
      "getFinalFormData",
      "getIdNumber",
      "getGivenName",
      "getFamilyName",
      "getProduct",
      "getCert",
      "getSignature",
      "getOcspResponse",
      "getOrderComplete",
      "getEmail",
      "getPhone",
      "getPreferredContact"
    ]),
  },
  methods: {
    sendAllToKaddio() {

      const kaddioData = {
        formId: process.env.VUE_APP_KADDIO_FORM_ID,
        pnr: this.getIdNumber,
        answers: [
          [
            this.email,
            this.orderId, // KADDIO: order_id
            this.product,  // KADDIO: order_produkt
            this.orderCompletedAt, // KADDIO: order_skapad_datum
            this.phone  // KADDIO: order_telefon   
          ],
          [
            this.getFinalFormData, // KADDIO: form_data
          ],
          [
            this.getSignature, // KADDIO: bankid_signature
            this.getOcspResponse, // KADDIO: bankid_ocsp,
            this.getCert.notBefore, // KADDIO: bankid_cert_notbefore,
            this.getCert.notAfter, // KADDIO: bankid_cert_notafter
          ]
        ],
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email
      }

      // prevent posting form twice
      if (this.getIdNumber !== '') {

        axios({
            method: "post",
            url: process.env.VUE_APP_API_BASE_URL + "sendtokaddio",
            data: kaddioData,
            headers: {
              "Content-Type": "application/json"
            }
        })
        .then(response => { 
          // eslint-disable-next-line
          console.log("Kaddio data sent:" + response);

          // window.localStorage.removeItem('vuex');

          this.$store.commit( 'persist/setIdentificationNumber', { identificationNumber: '' } )
          this.$store.commit( 'persist/setName', { givenName: '', familyName: '' } )
          this.$store.commit( 'persist/setFamilyName', { familyName: '' } )
          this.$store.commit( 'persist/setProduct', { product: '' })
          this.$store.commit( 'persist/setVerificationData', { cert: '', signature: '', ocspResponse: '' } )
          this.$store.commit( 'persist/setFinalFormData', { finalFormData: '' })
          this.$store.commit( 'persist/setEmail', { email: '' })
          this.$store.commit( 'persist/setPhone', { phone: '' })
          this.$store.commit( 'persist/setPreferredContact', { preferredContact: '' })

          // Send notification for psychology request
          if (this.getConfirmationType == 'psychologist') {
            // eslint-disable-next-line
            console.log("send notification");

            axios({
              method: "get",
              url: process.env.VUE_APP_API_BASE_URL + "notification",
              params: {
                  name: this.firstname + " " + this.lastname,
                  ordernumber: this.orderId,
                  email: this.email,
                  phone: this.phone,
                  preferredContact: this.preferredContact
              }
            })
              .then(response => {
                  // eslint-disable-next-line
                  if (response.data.Messages[0].Status === 'success') {
                    // eslint-disable-next-line
                    console.log("Notification succesfully sent")
                    this.everythingHasBeenConfirmed = true

                    pushCheckoutEventToDataLayer('psychologist-request-complete')
                  }
                })
                /* eslint-disable no-unused-vars */
                .catch(response => {
                  this.response = response
              })

          }

          return true
        })
        .catch(response => {
          // eslint-disable-next-line
          console.log("Kaddio data could not be posted:" + response)
          return false
        })

      } else {
        // eslint-disable-next-line
        console.log("No data available. Redirecting to start page.")
        this.$router.push('/')
      }

    },
    acknowledgeOrder() {
      axios({
          method: "get",
          url: process.env.VUE_APP_API_BASE_URL + "acknowledgeorder/" + this.sid,
      }).then(response => {
          // eslint-disable-next-line
          console.log(response);
          return true;
      })
    }
  },
  mounted() {
      if (!this.getShowConfirmation) {
        this.$router.push('/');
      } else {

        if (this.getConfirmationType == 'recipe') {
          axios({
              method: "get",
              url: process.env.VUE_APP_API_BASE_URL + "checkout/" + this.sid,
          })
            .then(response => {
              
                this.response = response.data

                generateCheckout(response.data.html_snippet);

                this.firstname = response.data.billing_address.given_name
                this.lastname = response.data.billing_address.family_name
                this.email = response.data.billing_address.email

                this.orderId = response.data.order_id
                this.product = response.data.order_lines[0].reference
                this.orderCompletedAt = response.data.completed_at
                this.phone = response.data.billing_address.phone

                if ( this.sendAllToKaddio() ) {
                  this.$store.commit( 'persist/setOrderComplete', { orderIsComplete: true })
                  this.acknowledgeOrder()
                }
              
              })
              /* eslint-disable no-unused-vars */
              .catch(response => {
                this.resultText = "Ingen åtkomst till Klarna. Vänligen kontakta kundtjänst."
                this.isLoading = false
              })
        }


        if (this.getConfirmationType == 'psychologist') {

          this.firstname = this.getGivenName
          this.lastname = this.getFamilyName
          this.email = this.getEmail
          this.phone = this.getPhone
          this.preferredContact = this.getPreferredContact

          this.orderId = "PSY-" + parseInt(Math.random()*1000000000, 10)
          this.product = "Psykologisk behandling" + " (kontaktas via " + this.preferredContact + ")"
          this.orderCompletedAt = new Date().toLocaleString();

          if ( this.sendAllToKaddio() ) { 
              this.$store.commit( 'persist/setOrderComplete', { orderIsComplete: true })
          } // end sendToKaddio

        } // end confirmationType
        
      }
    }
}

function generateCheckout(html) {

  window.dataLayer.push({
    'event': 'checkout-complete'
  });

  var checkoutContainer = document.getElementById('klarna-confirmation')
  checkoutContainer.innerHTML = html
  var scriptsTags = checkoutContainer.getElementsByTagName('script')
  // This is necessary otherwise the scripts tags are not going to be evaluated
  for (var i = 0; i < scriptsTags.length; i++) {
      var parentNode = scriptsTags[i].parentNode
      var newScriptTag = document.createElement('script')
      newScriptTag.type = 'text/javascript'
      newScriptTag.text = scriptsTags[i].text
      parentNode.removeChild(scriptsTags[i])
      parentNode.appendChild(newScriptTag)
  }
}

function pushCheckoutEventToDataLayer(eventName) {
  window.dataLayer.push({
    'event': eventName
  });
}

</script>
<style scoped>
  .form-error-message {
    text-align: center;
  }
  .form-button {
      background: #c7e8e7;
      border-radius: 0px;
      padding: 0.7em 2em;
      font-size: 1em;
      letter-spacing: 0.4px;
  }
</style>